// PROGRAM: Cart — Cart state, add/remove/change, drawer, savings calc
// Reads Liquid data from window.CARTOS_DATA (set by inline script)

(function() {
    'use strict';

    // Liquid data injected by inline script before this file loads
    var DATA = window.CARTOS_DATA || {};

    var Cart = {
        windowEl: null,
        contentEl: null,
        widgetCountEl: null,
        widgetEl: null,
        widgetStackEl: null,
        widgetSavingsEl: null,
        cartBottomCountEl: null,
        pageCartContentEl: null,

        // Debounce timer for batching rapid quantity clicks
        _changeTimer: null,
        _changePending: false,

        // [DISCOUNTS] - Data System
        savingsThresholds: [
            { amount: 99, reward: 'FREE SHIPPING', label: 'FREE SHIP', icon: '→' },
            { amount: 120, reward: '10% OFF', label: '10% OFF', icon: '→' },
            { amount: 200, reward: '15% OFF', label: '15% OFF', icon: '→' },
            { amount: 350, reward: '20% OFF', label: '20% OFF', icon: '→' }
        ],

        // Wholesale pricing data
        wholesalePricing: [
            { quantity: '1 DOZEN', price: 60, label: '1dz', theme: 'blue' },
            { quantity: '3 DOZEN', price: 50, label: '3dz', theme: 'green' },
            { quantity: '5 DOZEN', price: 40, label: '5dz', theme: 'gold', badge: 'BEST VALUE' }
        ],

        // Member detection — set from CARTOS_DATA (Liquid-injected)
        isLoggedIn: DATA.isLoggedIn || false,
        customerName: DATA.customerName || '',

        // Use PROGRAMS engine for products (single source of truth)
        get recommendedProducts() { return window.PROGRAMS ? (PROGRAMS.products || []) : []; },

        cachedCart: null,

        // Check and sync login state
        recheckLogin: function() {
            // Re-read from DATA (set by Liquid inline script)
            var liquidCustomer = DATA.isLoggedIn || false;
            var liquidName = DATA.customerName || '';
            if (!liquidCustomer) {
                localStorage.removeItem('retard_global_member');
                this.isLoggedIn = false;
                this.customerName = '';
                return;
            }
            this.isLoggedIn = true;
            this.customerName = liquidName || 'Member';
            var storedMember = localStorage.getItem('retard_global_member');
            if (storedMember) {
                try { var parsed = JSON.parse(storedMember); if (parsed.name) this.customerName = parsed.name; } catch(e) {}
            }
        },

        init: function() {
            // Resolve DOM elements
            this.windowEl = document.getElementById('retro-cart-window');
            this.contentEl = document.getElementById('retro-cart-content');
            this.widgetCountEl = document.getElementById('widget-count');
            this.widgetEl = document.getElementById('retro-taskbar-widget');
            this.widgetStackEl = document.getElementById('retro-floating-buttons');
            this.widgetSavingsEl = document.getElementById('widget-savings');
            this.cartBottomCountEl = document.getElementById('cart-bottom-count');
            this.pageCartContentEl = document.getElementById('retro-page-cart-content');

            // Clear on logout detection
            if (document.referrer.includes('/account/logout') ||
                window.location.search.includes('logout=true') ||
                window.location.pathname.includes('/account/login')) {
                localStorage.removeItem('retard_global_member');
            }
            this.recheckLogin();
            // Intercept all add to cart forms
            var self = this;
            document.addEventListener('submit', function(e) {
                if (e.target.action && e.target.action.includes('/cart/add')) {
                    e.preventDefault();
                    self.addItem(new FormData(e.target));
                }
            });
            this.fetchCart();
        },

        toggle: function() {
            const isActive = this.windowEl.classList.contains('active');
            const backdrop = document.getElementById('cart-backdrop');
            if (isActive) {
                this.windowEl.classList.remove('active');
                document.body.classList.remove('cart-open');
                if(backdrop) backdrop.classList.remove('active');
            } else {
                this.windowEl.classList.add('active');
                document.body.classList.add('cart-open');
                if(backdrop) backdrop.classList.add('active');
                this.fetchCart();
            }
        },

        addItem: function(formData) {
            var self = this;
            // Cancel any pending debounced quantity change
            if (this._changeTimer) { clearTimeout(this._changeTimer); this._changeTimer = null; }
            this._changePending = true;
            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(function(res) {
                if (!res.ok) throw new Error('Cart add failed: ' + res.status);
                return res.json();
            })
            .then(function(item) {
                self._changePending = false;
                self.fetchCart();
                if (window.location.pathname === '/cart') {
                    return;
                }
                var backdrop = document.getElementById('cart-backdrop');
                self.windowEl.classList.add('active');
                document.body.classList.add('cart-open');
                if(backdrop) backdrop.classList.add('active');
            })
            .catch(function(err) {
                console.error('CartOS addItem Error:', err);
                self._changePending = false;
                // Recovery: fetch actual state
                self.fetchCart();
            });
        },

        quickAdd: function(variantId) {
            var formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', 1);
            this.addItem(formData);
        },

        changeItem: function(key, qty) {
            var self = this;

            // INSTANT optimistic update — mutate cachedCart directly so
            // the next rapid click reads the already-updated quantity.
            // This makes every click feel instant regardless of network.
            if (this.cachedCart) {
                var itemIndex = -1;
                for (var i = 0; i < this.cachedCart.items.length; i++) {
                    if (this.cachedCart.items[i].key === key) { itemIndex = i; break; }
                }
                if (itemIndex !== -1) {
                    var oldQty = this.cachedCart.items[itemIndex].quantity;
                    var pricePer = this.cachedCart.items[itemIndex].line_price / oldQty;
                    if (qty === 0) {
                        this.cachedCart.total_price -= this.cachedCart.items[itemIndex].line_price;
                        this.cachedCart.item_count -= oldQty;
                        this.cachedCart.items.splice(itemIndex, 1);
                    } else {
                        var qtyDiff = qty - oldQty;
                        this.cachedCart.items[itemIndex].quantity = qty;
                        this.cachedCart.items[itemIndex].line_price = pricePer * qty;
                        this.cachedCart.total_price += pricePer * qtyDiff;
                        this.cachedCart.item_count += qtyDiff;
                    }
                    // Re-render immediately with updated cachedCart
                    this.render(this.cachedCart);
                    this.widgetCountEl.innerText = this.cachedCart.item_count;
                    if(this.cartBottomCountEl) this.cartBottomCountEl.innerText = this.cachedCart.item_count;
                    this.updateSavingsDisplays(this.cachedCart);
                    this.updateMemberProgressBar(this.cachedCart);
                }
            }

            // Debounce the server request — wait 150ms for clicks to settle,
            // then send ONE request with the final quantity.
            if (this._changeTimer) clearTimeout(this._changeTimer);
            this._changeTimer = setTimeout(function() {
                self._changeTimer = null;
                self._syncChange(key, qty);
            }, 150);
        },

        _syncChange: function(key, qty) {
            var self = this;
            // Find the actual current quantity from cachedCart (may have changed
            // since the debounce was scheduled if user kept clicking)
            var finalQty = qty;
            if (this.cachedCart) {
                for (var i = 0; i < this.cachedCart.items.length; i++) {
                    if (this.cachedCart.items[i].key === key) {
                        finalQty = this.cachedCart.items[i].quantity;
                        break;
                    }
                }
                // Item was removed (qty went to 0)
                var found = false;
                for (var i = 0; i < this.cachedCart.items.length; i++) {
                    if (this.cachedCart.items[i].key === key) { found = true; break; }
                }
                if (!found) finalQty = 0;
            }

            this._changePending = true;
            fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: finalQty })
            })
            .then(function(res) {
                if (!res.ok) throw new Error('Cart change failed: ' + res.status);
                return res.json();
            })
            .then(function(cart) {
                self._changePending = false;
                self.cachedCart = cart;
                self.render(cart);
                self.widgetCountEl.innerText = cart.item_count;
                if(self.cartBottomCountEl) self.cartBottomCountEl.innerText = cart.item_count;
                self.updateSavingsDisplays(cart);
                self.updateMemberProgressBar(cart);
                // Emit event for cross-program communication
                if (window.PROGRAMS && PROGRAMS.emit) PROGRAMS.emit('cart:updated', cart);
            })
            .catch(function(err) {
                console.error('CartOS Error:', err);
                self._changePending = false;
                // Recovery: re-fetch actual cart state from server
                self.fetchCart();
            });
        },

        fetchCart: function() {
            var self = this;
            fetch('/cart.js')
            .then(function(res) {
                if (!res.ok) throw new Error('Cart fetch failed: ' + res.status);
                return res.json();
            })
            .then(function(cart) {
                self.cachedCart = cart;
                self.render(cart);
                self.widgetCountEl.innerText = cart.item_count;
                if(self.cartBottomCountEl) self.cartBottomCountEl.innerText = cart.item_count;
                self.updateSavingsDisplays(cart);
                self.updateMemberProgressBar(cart);
                // Emit event for cross-program communication
                if (window.PROGRAMS && PROGRAMS.emit) PROGRAMS.emit('cart:updated', cart);
            })
            .catch(function(err) {
                console.error('CartOS fetchCart Error:', err);
            });
        },

        updateSavingsDisplays: function(cart) {
            var total = this.baseTotal(cart);
            var freeShipStr = this.formatBase(99);
            if (this.widgetSavingsEl) {
                if (total > 0 && !this.isLoggedIn) {
                    this.widgetSavingsEl.textContent = 'Save 15%';
                    this.widgetSavingsEl.classList.add('active');
                } else {
                    this.widgetSavingsEl.classList.remove('active');
                }
            }

            var guestPortalSavings = document.querySelectorAll('.guest-portal-savings');
            var guestPortalDiscount = document.querySelectorAll('.guest-portal-discount');

            var discountPercent = 0;
            if (total >= 350) discountPercent = 20;
            else if (total >= 200) discountPercent = 15;
            else if (total >= 120) discountPercent = 10;
            else if (total >= 99) discountPercent = 0;

            var savings = this.formatBase(total * (discountPercent / 100));

            guestPortalSavings.forEach(function(el) {
                if (total <= 0) {
                    return;
                } else if (discountPercent > 0) {
                    el.textContent = savings;
                    el.style.fontSize = '';
                } else {
                    el.textContent = 'FREE SHIPPING';
                    el.style.fontSize = '48px';
                }
            });
            guestPortalDiscount.forEach(function(el) {
                if (total <= 0) {
                    return;
                } else if (discountPercent > 0) {
                    el.textContent = discountPercent + '%';
                    el.parentElement.style.display = '';
                } else {
                    el.parentElement.style.display = 'none';
                }
            });

            if (typeof PROGRAMS !== 'undefined') {
                PROGRAMS.cartSavings = total * (discountPercent / 100);
                PROGRAMS.cartTotal = total;
            }

            var tierLabel = '';
            if (discountPercent === 20) tierLabel = '20% VIP';
            else if (discountPercent === 15) tierLabel = '15% off';
            else if (discountPercent === 10) tierLabel = '10% off';
            else if (total >= 99) tierLabel = 'FREE SHIPPING';

            var cartSavingsDisplays = document.querySelectorAll('.cart-savings-display');
            var cartSavingsHeaders = document.querySelectorAll('.cart-savings-header');
            var cartSavingsSubtexts = document.querySelectorAll('.cart-savings-subtext');

            cartSavingsDisplays.forEach(function(el) {
                if (total >= 120 && discountPercent > 0) {
                    el.textContent = savings;
                } else {
                    el.textContent = 'FREE SHIPPING';
                }
            });

            cartSavingsHeaders.forEach(function(el) {
                if (total >= 120 && discountPercent > 0) {
                    el.innerHTML = '<font face="Arial" size="1" color="#666">You could save</font><br>';
                } else {
                    el.innerHTML = '';
                }
            });

            cartSavingsSubtexts.forEach(function(el) {
                if (total >= 120 && discountPercent > 0) {
                    el.textContent = tierLabel + ' with Membership';
                } else {
                    el.textContent = 'AVAILABLE AT ' + freeShipStr + '+';
                }
            });
        },

        updateMemberProgressBar: function(cart) {
            var progressLabel = document.getElementById('msd-progress-label');
            var progressFill = document.getElementById('msd-progress-fill');
            var tiersContainer = document.getElementById('msd-tiers');
            if (!progressLabel || !progressFill || !tiersContainer) return;

            var total = this.baseTotal(cart);
            var thresholds = this.savingsThresholds;
            var maxThreshold = thresholds[thresholds.length - 1].amount;
            var progress = Math.min((total / maxThreshold) * 100, 100);
            progressFill.style.width = progress + '%';

            var currentTierIndex = -1;
            var nextTier = null;
            var needed = 0;
            for (var i = 0; i < thresholds.length; i++) {
                if (total >= thresholds[i].amount) {
                    currentTierIndex = i;
                } else if (!nextTier) {
                    nextTier = thresholds[i];
                    needed = thresholds[i].amount - total;
                }
            }

            if (total === 0) {
                progressLabel.textContent = 'Add items to unlock member savings!';
            } else if (nextTier) {
                progressLabel.textContent = 'Next: ' + nextTier.reward + ' (' + this.formatBase(needed) + ' to go)';
            } else {
                progressLabel.textContent = 'MAXIMUM SAVINGS UNLOCKED!';
            }

            var tiersHtml = '';
            for (var i = 0; i < thresholds.length; i++) {
                var tier = thresholds[i];
                var tierClass = '';
                if (total >= tier.amount) {
                    tierClass = 'unlocked';
                } else if (i === currentTierIndex + 1) {
                    tierClass = 'current';
                }
                tiersHtml += '<div class="msd-tier ' + tierClass + '">' +
                    '<span class="msd-tier-icon">' + tier.icon + '</span>' +
                    '<span class="msd-tier-label">' + tier.label + '</span>' +
                    '<span class="msd-tier-amount">' + this.formatBase(tier.amount) + '</span>' +
                '</div>';
            }
            tiersContainer.innerHTML = tiersHtml;
        },

        // ── Currency (Shopify Markets presentment) ───────────────────────
        // The drawer is fully JS-rendered, so it must format money in the
        // shopper's PRESENTMENT currency — not a hardcoded "$". cart.js amounts
        // (total_price, line_price…) are already in presentment subunits, e.g.
        // a 245 zł cart returns 24500 with Shopify.currency.active === 'PLN'.
        // For a USD shopper rate===1 and these reduce to the original output,
        // so the US experience is byte-for-byte unchanged.
        currencyCode: function() {
            return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        },
        // Presentment units per 1 USD of base price (PLN→~3.77, USD→1).
        currencyRate: function() {
            var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
            return (r && r > 0) ? r : 1;
        },
        // Format presentment-currency SUBUNITS (cart.js cents) → "245,00 zł" / "¥10,700" / "$245.00".
        formatMoney: function(cents) {
            var amount = (Number(cents) || 0) / 100;
            try {
                return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.currencyCode() }).format(amount);
            } catch (e) {
                return '$' + amount.toFixed(2);
            }
        },
        // Format a USD-denominated marketing amount (a $99 threshold, "$5 more")
        // in the shopper's currency. Decimal places follow the CURRENCY (JPY/KRW→0,
        // PLN/USD→2, KWD→3) — NOT the converted number's integer-ness — so the
        // $99 free-ship bar reads "¥16,212" not "¥16,211.95"; whole amounts stay
        // clean ("$99", not "$99.00").
        formatBase: function(usd) {
            var amount = (Number(usd) || 0) * this.currencyRate();
            var code = this.currencyCode();
            try {
                var maxFrac = new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).resolvedOptions().maximumFractionDigits;
                var factor = Math.pow(10, maxFrac);
                var rounded = Math.round(amount * factor) / factor;
                var fd = (maxFrac > 0 && Math.round(rounded) !== rounded) ? maxFrac : 0;
                return new Intl.NumberFormat(undefined, { style: 'currency', currency: code, minimumFractionDigits: fd, maximumFractionDigits: fd }).format(rounded);
            } catch (e) {
                return '$' + (Number.isInteger(amount) ? amount : amount.toFixed(2));
            }
        },
        // Cart total expressed in USD base, for comparing against the USD reward
        // thresholds (99/120/200/350). USD shopper → unchanged (rate 1).
        baseTotal: function(cart) {
            return (cart.total_price / 100) / this.currencyRate();
        },

        generateHTML: function(cart) {
            var self = this;

            // ---- EMPTY ----
            if (cart.item_count === 0) {
                return '<div class="ctc ctc-empty-wrap">' +
                    '<div class="ctc-empty">' +
                    '<div class="ctc-empty-h">YOUR CART IS EMPTY</div>' +
                    '<div class="ctc-empty-s">No drops in the bag yet.</div>' +
                    '<a href="/collections/all" class="ctc-btn ctc-btn-mag">SHOP THE DROP &rarr;</a>' +
                    '</div></div>';
            }

            // ---- TOTALS / MEMBER PRICING (logic preserved verbatim) ----
            // total    = presentment amount (drives money displays via formatMoney).
            // tierTotal = same spend in USD base (drives 99/120/200/350 threshold compares).
            var total = cart.total_price / 100;
            var tierTotal = this.baseTotal(cart);
            var thresholds = this.savingsThresholds;
            var currentTierIndex = -1;
            for (var i = 0; i < thresholds.length; i++) {
                if (tierTotal >= thresholds[i].amount) { currentTierIndex = i; }
            }
            var formattedTotal = this.formatMoney(cart.total_price);

            // Q4 2026: member ladder retired (automatic discounts expired) — nobody gets a
            // client-side discounted total; free shipping is universal.
            var discountPercent = 0, discountLabel = '';
            var discountedTotal = total * (1 - discountPercent / 100);
            var savings = total - discountedTotal;
            var formattedDiscountedTotal = this.formatMoney(Math.round(discountedTotal * 100));
            var formattedSavings = this.formatMoney(Math.round(savings * 100));

            // ---- LINE ITEMS ----
            var itemsHtml = '';
            cart.items.forEach(function(item) {
                var formattedPrice = self.formatMoney(item.line_price);
                var title = item.product_title.length > 38 ? item.product_title.substring(0, 38) + '...' : item.product_title;
                itemsHtml += '<div class="ctc-line">' +
                    '<a href="' + item.url + '" class="ctc-thumb"><img src="' + item.image + '" alt="' + item.product_title + '"></a>' +
                    '<div class="ctc-info">' +
                    '<div class="ctc-title">' + title + '</div>' +
                    (item.variant_title ? '<div class="ctc-variant">' + item.variant_title + '</div>' : '') +
                    '<div class="ctc-qty">' +
                    '<button type="button" aria-label="Decrease quantity" onclick="CartOS.changeItem(\'' + item.key + '\', ' + (item.quantity - 1) + ')">&minus;</button>' +
                    '<span>' + item.quantity + '</span>' +
                    '<button type="button" aria-label="Increase quantity" onclick="CartOS.changeItem(\'' + item.key + '\', ' + (item.quantity + 1) + ')">+</button>' +
                    '</div>' +
                    '</div>' +
                    '<div class="ctc-side">' +
                    '<span class="ctc-rm" role="button" aria-label="Remove item" onclick="CartOS.changeItem(\'' + item.key + '\', 0)">&times;</span>' +
                    '<div class="ctc-price">' + formattedPrice + '</div>' +
                    '</div>' +
                    '</div>';
            });

            // ---- CHRISTMAS STRIP: combo upsell while the cart is only single hats ----
            var hasCombo = cart.items.some(function(it) { return /combo|pack/i.test(it.handle || ''); });
            var tierHtml = '<div class="ctc-tier"><div class="ctc-tier-msg">' +
                (hasCombo
                    ? '&#9733; CHRISTMAS FREE SHIPPING &middot; ORDER BY DEC 11'
                    : '<a href="/products/2-pack-retard-trucker-hats">2 HATS $110 &middot; 4 HATS $200 &rarr;</a>') +
                '</div></div>';

            // ---- SAVINGS (members only) ----
            var savingsHtml = discountPercent > 0
                ? '<div class="ctc-save">MEMBER ' + discountLabel + ' &middot; YOU SAVE ' + formattedSavings + '</div>'
                : '';

            // ---- SUBTOTAL ----
            var subtotalHtml = '<div class="ctc-subtotal">' +
                '<span class="ctc-subtotal-l">SUBTOTAL</span>' +
                (discountPercent > 0
                    ? '<span class="ctc-subtotal-v"><s>' + formattedTotal + '</s> ' + formattedDiscountedTotal + '</span>'
                    : '<span class="ctc-subtotal-v">' + formattedTotal + '</span>') +
                '</div>';

            var guestHtml = '';

            return '<div class="ctc">' +
                '<div class="ctc-items">' + itemsHtml + '</div>' +
                tierHtml +
                savingsHtml +
                subtotalHtml +
                '<a href="/checkout" class="ctc-btn ctc-btn-mag ctc-checkout">CHECKOUT &rarr;</a>' +
                guestHtml +
                '<div class="ctc-trust">CHRISTMAS FREE SHIPPING &middot; 30-DAY RETURNS &middot; SECURE</div>' +
                '<a href="/cart" class="ctc-viewcart">VIEW FULL CART &rarr;</a>' +
                '</div>';
        },

        toggleAddMore: function(btn) {
            var container = btn.closest('.add-more-container');
            if (!container) return;
            var panel = container.querySelector('.add-more-panel');
            var text = container.querySelector('.add-more-text');
            if (panel && text) {
                if (panel.classList.contains('open')) {
                    panel.classList.remove('open');
                    text.innerHTML = '+ Add More Items';
                } else {
                    panel.classList.add('open');
                    text.innerHTML = '− Close';
                }
            }
        },

        toggleQuickAddRec: function(btn) {
            var container = btn.closest('.quick-add-container');
            if (!container) return;
            var panel = container.querySelector('.quick-add-panel');
            var text = container.querySelector('.quick-add-text');
            if (panel && text) {
                if (panel.classList.contains('open')) {
                    panel.classList.remove('open');
                    text.innerHTML = 'QUICK ADD CART';
                } else {
                    panel.classList.add('open');
                    text.innerHTML = '− CLOSE QUICK ADD';
                }
            }
        },

        // Legacy upsell/quick-add panels removed in the contract re-skin; kept as
        // no-ops so any stray reference is harmless.
        generateQuickAddItems: function() { return ''; },

        generateRecommendedProducts: function(cart) { return ''; },

        generateMembershipProgressBar: function(cartTotal) { return ''; },

        generateMembershipCTA: function(cartTotal) { return ''; },

        render: function(cart) {
            var html = this.generateHTML(cart);
            if (this.contentEl) this.contentEl.innerHTML = html;
            var pageCart = document.getElementById('retro-page-cart-content');
            if (pageCart) pageCart.innerHTML = html;
        }
    };

    // Register with PROGRAMS
    window.PROGRAMS.register('Cart', Cart);

    // BACKWARD COMPATIBILITY: window.CartOS = PROGRAMS.Cart
    window.CartOS = Cart;

})();
